// BottomTabBar – bottom navigation between the main sections.

import React from 'react';
import { NavLink } from 'react-router-dom';
import { FolderOpen, Monitor, Settings, Ticket } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function BottomTabBar() {
  const { isAdmin, isOperator } = useAuth();

  const tabClass = ({ isActive }: { isActive: boolean }) =>
    [
      'flex flex-col items-center justify-center gap-0.5 px-4 py-2 rounded-xl text-xs font-medium transition-all duration-150 select-none',
      isActive
        ? 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-500/10'
        : 'text-gray-500 hover:text-gray-800 hover:bg-gray-100 dark:text-slate-400 dark:hover:text-slate-100 dark:hover:bg-slate-800',
    ].join(' ');

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t"
      style={{
        background: 'var(--chrome-bg)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderColor: 'var(--chrome-border)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="flex h-[60px] items-center justify-around">
        <NavLink to="/" end className={tabClass}>
          <Monitor className="h-5 w-5" />
          <span>Devices</span>
        </NavLink>

        <NavLink to="/file-explorer" className={tabClass}>
          <FolderOpen className="h-5 w-5" />
          <span>Files</span>
        </NavLink>

        {(isAdmin || isOperator) && (
          <NavLink to="/events" className={tabClass}>
            <Ticket className="h-5 w-5" />
            <span>Events</span>
          </NavLink>
        )}

        {isAdmin && (
          <NavLink to="/admin" className={tabClass}>
            <Settings className="h-5 w-5" />
            <span>Admin</span>
          </NavLink>
        )}
      </div>
    </nav>
  );
}
